import ApiClient from "./apiClient";
import { QueriesApi } from "./apiTypes";

const configurationService = {

  getConfiguratonsList:(queries:QueriesApi) => ApiClient.get(`configurations`,{
    params:{
      ...queries,
    }
  }),
  getBillingConfigurations:(id:any) => ApiClient.get(`configurations/${id}/billing`),
  getOpenstackConfigurations:(id:any) => ApiClient.get(`configurations/${id}/openstack`),
  updateBillingConfigurations:(id:any, data:any) => {
    const formData = new FormData();
    formData.append('data', JSON.stringify(data));
    return ApiClient.put(`configurations/${id}/billing`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
  },
  updateOpenstackConfigurations:(id:any, data:any) => ApiClient.put(`configurations/${id}/openstack`, data),
}

export default configurationService